import Splide from '@splidejs/splide';
import { Modal } from 'bootstrap'
import { Fancybox } from '@fancyapps/ui'


const object = vnObject

document.addEventListener('DOMContentLoaded', function () {

    /*
    =========================
    CONFIRMATION AJOUT PANIER
    (après redirection ?vn_added=1 depuis le site parent)
    =========================
    */

    const cartParams = new URLSearchParams(window.location.search);

    if (cartParams.get('vn_added') === '1') {

        const confirmEl = document.getElementById('cartConfirmModal');

        if (confirmEl) {
            new Modal(confirmEl).show();
        }

        // Nettoyer l'URL pour éviter la réapparition de la modale au rafraîchissement
        cartParams.delete('vn_added');
        const query = cartParams.toString();
        const cleanUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
        window.history.replaceState({}, '', cleanUrl);
    }

    /*
    =========================
    Fancybox
    =========================
    */
    Fancybox.bind(`[data-gallery="gallery-product"]`, {
        groupAll: true,
        Toolbar: {
            display: {
                left: [],
                middle: [],
                right: ['close'],
            },
        },
        Thumbs: {
            type: 'classic',
        },
    })

    /*
    =========================
    SPLIDE
    =========================
    */

    const mainEl = document.querySelector('#main-slider');
    const thumbEl = document.querySelector('#thumbnail-slider');

    if (mainEl && thumbEl) {

        const main = new Splide(mainEl, {
            type: 'fade',
            pagination: false,
            arrows: false,
        });

        const thumbnails = new Splide(thumbEl, {
            fixedWidth: 60,
            fixedHeight: 60,
            gap: 3,
            rewind: true,
            pagination: false,
            arrows: false,
            isNavigation: true,
            focus: 'center',
        });

        thumbnails.mount();
        main.sync(thumbnails);
        main.mount();
    }

    /*
    =========================
    PRIX VARIATION (MutationObserver)
    =========================
    */

    const priceContainer = document.querySelector('.vn-price');
    const variationContainer = document.querySelector('.woocommerce-variation');

    if (priceContainer && variationContainer) {

        const observer = new MutationObserver(function () {
            const variationPrice = variationContainer.querySelector('.woocommerce-variation-price');

            if (variationPrice && variationPrice.innerHTML.trim() !== '') {
                priceContainer.innerHTML = variationPrice.innerHTML;
            }
        });

        observer.observe(variationContainer, {
            childList: true,
            subtree: true
        });
    }

    /*
    =========================
    VARIATION BUTTONS
    =========================
    */

    document.querySelectorAll('.variation-buttons').forEach(group => {

        const attribute = group.dataset.attribute;
        const select = document.querySelector('select[name="attribute_' + attribute + '"]');

        if (!select) return;

        group.querySelectorAll('.variation-btn').forEach(btn => {

            btn.addEventListener('click', function () {

                // reset active
                group.querySelectorAll('.variation-btn').forEach(b => b.classList.remove('active'));

                // active button
                this.classList.add('active');

                // update select
                select.value = this.dataset.value;

                // trigger WooCommerce
                select.dispatchEvent(new Event('change', { bubbles: true }));
            });

        });
    });

    /*
    =========================
    RESET VARIATIONS
    =========================
    */

    document.querySelectorAll('.reset_variations').forEach(reset => {

        reset.addEventListener('click', function () {

            document.querySelectorAll('.variation-btn').forEach(btn => {
                btn.classList.remove('active');
            });

        });

    });

    /*
    =========================
    QUANTITY + / -
    =========================
    */

    const cartForm = document.querySelector('form.cart');

    if (cartForm) {

        const qtyInput = cartForm.querySelector('input.qty');
        const qtyText = cartForm.querySelector('span#qty');
        const plusBtn = cartForm.querySelector('span#plus');
        const minusBtn = cartForm.querySelector('span#minus');

        if (qtyInput && qtyText && plusBtn && minusBtn) {

            const updateQtyText = () => {
                qtyText.textContent = qtyInput.value;
            };

            minusBtn.addEventListener('click', function () {

                const min = parseInt(qtyInput.getAttribute('min') || 1);
                let value = parseInt(qtyInput.value || 1);

                if (value > min) {
                    qtyInput.value = value - 1;
                    updateQtyText();
                }
            });

            plusBtn.addEventListener('click', function () {

                const max = parseInt(qtyInput.getAttribute('max') || 9999);
                let value = parseInt(qtyInput.value || 1);

                if (value < max) {
                    qtyInput.value = value + 1;
                    updateQtyText();
                }
            });
        }
    }


    /*
    =========================
    PREVENT BUY ON MAIN SITE
    =========================
    */
    let currentVariationSku = null;

    /*
    WooCommerce native event (via jQuery interne)
    */
    jQuery(document).on('found_variation', function (event, variation) {

        // 🔥 IMPORTANT: SKU variation
        currentVariationSku = variation.sku || null;

    });

    document.addEventListener('click', (e) => {

        const btn = e.target.closest('.js-prevent-buy');
        if (!btn) return;

        e.preventDefault();

        const form = btn.closest('form.cart');
        if (!form) return;

        const qty = parseInt(form.querySelector('input.qty')?.value || 1);
        const sku = form.querySelector('.js-product-sku')?.value;
        const variationSku = currentVariationSku;

        const productData = {
            sku,
            quantity: qty,
            variation_sku: variationSku
        };

        sessionStorage.setItem('pendingProduct', JSON.stringify(productData));

        // reset
        currentVariationSku = null;

        const modal = new Modal(document.getElementById('shopsModal'));
        modal.show();
    });

    document.addEventListener('click', (e) => {

        const shop = e.target.closest('.js-other-shops');
        if (!shop) return;

        const stored = sessionStorage.getItem('pendingProduct');

        // normal navigation if nothing
        if (!stored) return;

        e.preventDefault();

        const product = JSON.parse(stored);
        const url = new URL(shop.href);

        if (product.sku) {
            url.searchParams.set('sku', product.sku);
            url.searchParams.set('qty', product.quantity);

            if (product.variation_sku) {
                url.searchParams.set('variation_sku', product.variation_sku);
            }
        }

        sessionStorage.removeItem('pendingProduct');

        window.location.href = url.toString();
    });
});
